import axios from "axios";
import CryptoJS from "crypto-js";
import { firebaseLogout } from "./firebase";
import { clearCookieUser } from "./authService";

const apiKey = process.env.REACT_APP_API_KEY;
const accessKey = process.env.REACT_APP_API_ACCESS_KEY;
const apiSecret = process.env.REACT_APP_API_SECRET;

// const api = axios.create({
//     baseURL: process.env.REACT_APP_API_BASE_URL,
//     headers: {
//         // "Content-Type": "application/json",
//         "x-api-key": process.env.REACT_APP_FIREBASE_APP_API_KEY,
//         "x-access-key": process.env.REACT_APP_API_ACCESS_KEY,
//     }
// });

// Optional interceptor
// api.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response?.status === 401) {
//             console.error("Unauthorized: Check your API Key");
//         }
//         return Promise.reject(error);
//     }
// );

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use((config) =>
{

  // Jakarta timestamp
  const now = new Date();
  const jakarta = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" })
  );

  const timestamp =
    jakarta.getFullYear() +
    "-" +
    String(jakarta.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(jakarta.getDate()).padStart(2, "0") +
    " " +
    String(jakarta.getHours()).padStart(2, "0") +
    ":" +
    String(jakarta.getMinutes()).padStart(2, "0") +
    ":" +
    String(jakarta.getSeconds()).padStart(2, "0");

  // Build request path
  const url = new URL(config.url, config.baseURL);
  const path = url.pathname + url.search;

  const data = path + "|" + timestamp;

  const signature = CryptoJS.HmacSHA256(data, apiSecret).toString(
    CryptoJS.enc.Hex
  );

  config.headers["x-api-key"] = apiKey;
  config.headers["x-access-key"] = accessKey;
  config.headers["x-timestamp"] = timestamp;
  config.headers["x-signature"] = signature;

  return config;
});


export default api;


/* ================= AUTH ================= */

export const apiLoginEmail = (formData) =>
  api.post("/v2/auth/login/pingingo", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });

export const apiLoginGoogle = (formData) =>
  api.post("/v2/auth/login/firebase-google", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });

/* ================= USER DATA ================= */

export const apiGetUserByToken = (token) =>
  api.get("/v2/users?token=" + token);


export const apiGetUserByTokenId = (id, token) =>
  api.get(`/v2/profile/${id}?token=${token}`);


/* ================= USER DATA ================= */

export const logOutUserFunction = async (formData) =>
{
  try
  {
    const res = await api.post(
      "/v2/auth/logout",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    // Log Out Fire Base ---------------------------------
    await firebaseLogout();

    // Clear Cookie -------------------------------------
    clearCookieUser();

    return res;

  }
  catch (err)
  {
    console.error("LOGOUT ERROR:", err);
    throw err;
  }
};


// api.interceptors.request.use(config => {
//     console.log("Request URL:", config.url);
//     console.log("Request headers:", config.headers);
//     return config;
// });


